import { useNavigate, useParams } from 'react-router-dom';

import { routes } from '@blockpulse3/data/shared';
import { CompanyCapitalType, useGetFundraisingQuery } from '@blockpulse3/graphql/hooks';

import { NewFundraisingUploadBankDetails } from '../NewFundraisingUploadBankDetails';

type Props = unknown;

/**
 * NewPrivateFundraisingCapitalFixedBankDetails.
 *
 * @returns {JSX.Element}
 */
export function NewPrivateFundraisingCapitalFixedBankDetails(): JSX.Element {
  const navigate = useNavigate();
  const { fundraisingId = '', companyId = '' } = useParams();

  const fundraisingRoutes = routes.workspace.fundraising.private;

  useGetFundraisingQuery({
    variables: {
      fundraisingId,
    },
    onCompleted: (data) => {
      if (data?.fundraising.company.capitalType !== CompanyCapitalType.FIXED) {
        navigate(routes.workspace.fmt(companyId));
      }
    },
    skip: !fundraisingId,
  });

  const handleFormSubmit = (): void => {
    if (!companyId) return;
    navigate(fundraisingRoutes.subscribers.fmt(companyId, fundraisingId));
  };

  const handleFormCancel = (): void => {
    navigate(fundraisingRoutes.documentation.fmt(companyId, fundraisingId));
  };

  return (
    <NewFundraisingUploadBankDetails onCancel={handleFormCancel} onSubmit={handleFormSubmit} />
  );
}

export type NewPrivateFundraisingCapitalFixedBankDetailsrops = Props;
